import { amountToNumber } from '../../../../util/shared/vue-global';
import { toIsoDate } from '../../../../util/shared/tmc-global';

export const juneResaleMainHeader = [
  {
    text: 'System ID',
    value: 'systemId',
    sortable: true,
  },
  {
    text: 'Property ID',
    value: 'mainPropertyOrParcelId',
    sortable: true,
    formatter: 'pId',
  },
  {
    text: 'Base Tax Year',
    value: 'mainTaxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'mainTaxId',
    sortable: true,
  },
  {
    text: 'Owner Name',
    value: 'mainCurrentOwnerName',
    sortable: true,
  },
  {
    text: 'Total Due',
    value: 'mainTotalDue',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Total Paid',
    value: 'mainTotalPaid',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
];

export const juneResaleBottomTableHeader = [
  {
    text: 'System ID',
    value: 'systemId',
    sortable: false,
  },
  {
    text: 'Property ID',
    value: 'propertyOrParcelId',
    sortable: false,
    formatter: 'pId',
  },
  {
    text: 'Tax Type',
    value: 'taxType',
    sortable: false,
    align: 'center',
  },
  {
    text: 'Tax Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'Tax District',
    value: 'schoolDistrict',
    sortable: false,
  },
  {
    text: 'Tax Amount Due',
    value: 'totalTaxDue',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Penalty',
    value: 'currentPenalty',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Total Fees',
    value: 'totalFeesDue',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Total Due',
    value: 'totalDue',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
];

export const juneResaleNameAndAddressesHeader = [
  {
    text: 'Owner Name',
    value: 'ownerName',
    sortable: false,
  },
  {
    text: 'C/O Name',
    value: 'inCareOf',
    sortable: false,
  },
  {
    text: 'Address1',
    value: 'Address1',
    sortable: false,
  },
  {
    text: 'Address2',
    value: 'Address2',
    sortable: false,
  },
  {
    text: 'Address3',
    value: 'Address3',
    sortable: false,
  },
  {
    text: 'City',
    value: 'city',
    sortable: false,
  },
  {
    text: 'State',
    value: 'state',
    sortable: false,
  },
  {
    text: 'Zip',
    value: 'zip',
    sortable: false,
  },
  {
    text: 'Country',
    value: 'country',
    sortable: false,
  },
  {
    text: 'Cert Mailer',
    value: 'printCertifiedMailer',
    formatter: 'flagToYorEmpty',
    sortable: false,
  },
];

export const resaleListActions = [
  { val: 0, listName: '' },
  { val: 1, listName: 'Remove Paid records' },
  { val: 2, listName: 'Pull All Records for Current Resale List' },
  { val: 3, listName: 'Remove Updated Owner Records' },
  { val: 4, listName: 'Disable Web Payments' },
  { val: 5, listName: 'Apply Fee' },
  { val: 6, listName: 'Create Publication' },
  { val: 7, listName: 'Data Export' },
];

export const resaleListActionsWhenResaleDateIsLessThanCurDate = [
  { val: 0, listName: '' },
  { val: 3, listName: 'Remove Updated Owner Records' },
  { val: 4, listName: 'Disable Web Payments' },
  { val: 5, listName: 'Apply Fee' },
  { val: 6, listName: 'Create Publication' },
  { val: 7, listName: 'Data Export' },
];

export const bidderRegistrationHeader = [
  {
    text: 'Reg#',
    value: 'regNumber',
    sortable: false,
  },
  {
    text: 'Name',
    value: 'bidderName',
    sortable: false,
  },
  {
    text: 'Address 1',
    value: 'addressOne',
    sortable: false,
  },
  {
    text: 'Address 2',
    value: 'addressTwo',
    sortable: false,
  },
  {
    text: 'City',
    value: 'city',
    sortable: false,
  },
  {
    text: 'State',
    value: 'state',
    sortable: false,
  },
  {
    text: 'Zip Code',
    value: 'zipCode',
    sortable: false,
  },
  {
    text: 'Phone Number',
    value: 'phoneNumber',
    sortable: false,
  },
  {
    text: 'Email Address',
    value: 'emailAddress',
    sortable: false,
  },
  {
    text: 'Total Deposits',
    value: 'totalDeposits',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Winning Bids Total',
    value: 'winningBidsTotal',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Total Withdrawals',
    value: 'totalWithdrawals',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Amount Due to Bidder',
    value: 'amountDueToBidder',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
];

export const bidderActivityHeader = [
  {
    text: 'Date',
    value: 'logDate',
    formatter: 'shortDate',
    sortable: false,
  },
  {
    text: 'Type',
    value: 'type',
    sortable: false,
  },
  {
    text: 'Amount',
    value: 'amount',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
];

export const dayOfSaleMainHeader = [
  {
    text: 'System ID',
    value: 'systemId',
  },
  {
    text: 'Property ID',
    value: 'mainPropertyOrParcelId',
    formatter: 'pId',
  },
  {
    text: 'Situs Address',
    value: 'mainSitusAddress',
    sortable: false,
  },
  {
    text: 'Owner Name',
    value: 'mainCurrentOwnerName',
  },
  {
    text: 'Tax ID',
    value: 'mainTaxId',
  },
  {
    text: 'Total Due',
    value: 'mainTotalDue',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: '2/3 Assessed + Cost/Fees',
    value: 'mainTwoThirdsAssessed',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Winning Bid',
    value: 'winningBid',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Reg#',
    value: 'regNumber',
    sortable: false,
  },
  {
    text: 'Excess resale',
    value: 'excessResale',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'County Owned',
    value: 'countyOwned',
    sortable: false,
    formatter: 'flagToYorEmpty',
  },
];

export const commissionerMainHeader = [
  {
    text: 'System ID',
    value: 'systemId',
    sortable: true,
  },
  {
    text: 'Property ID',
    value: 'propertyOrParcelId',
    sortable: true,
    formatter: 'pId',
  },
  {
    text: 'Sale Year',
    value: 'saleYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    sortable: true,
  },
  {
    text: 'Assessed Value',
    value: 'assessedValue',
    sortable: true,
  },
  {
    text: 'Name',
    value: 'ownerName',
    sortable: false,
  },
  {
    text: 'Legal Description',
    value: 'legalDesc',
    sortable: false,
  },
];

/**
 * Every field the user can type on the Commissioners Sale property record form, shaped for
 * upsertCommissionersSaleSelectedFields. Shared by the Save button and by the save-before-print
 * in the report handlers so the two can never write a different set of fields. Bid history is
 * not here - it is saved through its own full-record upsert.
 */
export const commissionersSaleSaveFields = (item) => {
  const rec = item || {};
  const itemToSent = {
    isItSold: rec.isItSold || false,
    saleYear: amountToNumber(rec.saleYear),
    _id: rec._id,
    commissionerTimeOfSale: rec.commissionerTimeOfSale || '',
    legalDesc: rec.legalDesc || '',
  };
  if (rec.commissionerPubDateOne) itemToSent.commissionerPubDateOne = toIsoDate(rec.commissionerPubDateOne);
  if (rec.commissionerDateOfSale) itemToSent.commissionerDateOfSale = toIsoDate(rec.commissionerDateOfSale);
  if (rec.commissionerDateOfMeeting) itemToSent.commissionerDateOfMeeting = toIsoDate(rec.commissionerDateOfMeeting);
  if (rec.commissionerPubDateTwo) itemToSent.commissionerPubDateTwo = toIsoDate(rec.commissionerPubDateTwo);
  if (rec.commissionerSaleFees) itemToSent.commissionerSaleFees = amountToNumber(rec.commissionerSaleFees);
  if (rec.commissionerPubDateThree) itemToSent.commissionerPubDateThree = toIsoDate(rec.commissionerPubDateThree);
  return itemToSent;
};

export const commissionerBidderMainHeader = [
  {
    text: 'Date',
    value: 'bidDate',
    formatter: 'shortDate',
    sortable: false,
  },
  {
    text: 'Reg #',
    value: 'regNumber',
    sortable: false,
  },
  {
    text: 'Bidder Name',
    value: 'bidderName',
    sortable: false,
  },
  {
    text: 'Bid Amount',
    value: 'bidAmount',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
];
